import React from "react";
import Logo from "../../resources/images/Footer_Logo.svg";
import BottomLine from "../../resources/images/Bottom_Line.svg";
import FacebookIcon from "../../resources/images/Facebook.svg";
import InstagramIcon from "../../resources/images/Instagram.svg";
import TwitterIcon from "../../resources/images/Twitter.svg";
import LinkedInIcon from "../../resources/images/Linkedin.svg";
import "./Footer.css";
import { Link } from "react-router-dom";

const footerLinks = [
  { label: "Home", path: "/" },
  { label: "About us", path: "/about-us" },
  {
    label: "Open jobs",
    path: "https://clientapps.jobadder.com/99415/bravix",
    external: { target: "_blank" },
  },
  { label: "Join us", path: "/join-us" },
  { label: "Contact us", path: "/reach-out" },
  { label: "Find talent", path: "/find-talent" },
  { label: "Privacy policy", path: "/privacy-policy" },
  { label: "Terms and conditions", path: "/terms-and-conditions" },
];

const socialLinks = [
  {
    icon: FacebookIcon,
    alt: "Facebook",
    path: "https://www.facebook.com/share/1B1RzgwD8Z/?mibextid=wwXIfr",
  },
  {
    icon: InstagramIcon,
    alt: "Instagram",
    path: "https://www.instagram.com/bravix.group",
  },
  // { icon: TwitterIcon, alt: "Twitter", path: "https://twitter.com" },
  {
    icon: LinkedInIcon,
    alt: "LinkedIn",
    path: "https://www.linkedin.com/company/bravix-group",
  },
];

const Footer = () => {
  return (
    <>
      <footer className="footer_section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="footer_top">
                <img src={Logo} alt={Logo} />
                <img src={BottomLine} alt={BottomLine} className="line" />
                <p>
                  Strengthening Commercial Construction through strategic talent
                  solutions
                </p>
              </div>
              <div className="footer_center">
                <ul>
                  {footerLinks.map((item, index) => (
                    <li key={index}>
                      {item.label === "Home" ? (
                        <Link
                          to={item.path}
                          onClick={() => {
                            if (window.location.pathname === "/") {
                              window.scrollTo({ top: 0, behavior: "smooth" });
                            }
                          }}
                        >
                          {item.label}
                        </Link>
                      ) : item.external ? (
                        <a
                          href={item.path}
                          target={item.external.target}
                          rel="noopener noreferrer"
                        >
                          {item.label}
                        </a>
                      ) : (
                        <Link to={item.path}>{item.label}</Link>
                      )}
                    </li>
                  ))}
                </ul>
                <ul>
                  {socialLinks.map((item, index) => (
                    <li key={index}>
                      <a
                        href={item.path}
                        className="icon"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={item.icon} alt={item.alt} />
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="footer_bottom">
                <p>
                  © {new Date().getFullYear()} Bravix Group all rights reserved
                </p>
                <h5>
                  Developed by{" "}
                  <Link target="_blank" to="https://jetrosolutions.com/">
                    Jetro Solutions
                  </Link>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
